var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"#F2F5F7"}},[_c('Navbar'),_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"sidenav"},[_c('Sidebar')],1),_c('div',{staticClass:"flex-grow-1 d-relative"},[(_vm.getLoading())?_c('Loader',{attrs:{"position":"absolute"}}):_vm._e(),_c('router-view')],1)]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }